export const locKeys = {
  seeAllTitle: "cars.seeAll.title",
  seeAllSubtitle: "cars.seeAll.subtitle",
  seeAllLink: "cars.seeAll.link",
  disclaimerPrefix: "cars.disclaimer.",
  passengerCount: "cars.offer.passenger.count",
  carModel: "cars.offer.carModel",
  perDay: "cars.offer.perday",
  total: "cars.offer.total",
  freshnessPrefix: "cars.offer.freshness.",
  airport: "cars.offer.location.airport",
  city: "cars.offer.location.city",
  cityWithoutProvince: "cars.offer.location.city.no.province",
  pickUpLocationText: "cars.pickup.location.text",
  locationDistanceText: "cars.offer.location.distance.from.city.center",
  mileageUnlimited: "car.mileage.unlimited",
  mileageLimited: "car.mileage.limited",
  mileageLimitedPrefix: "car.mileage.limit.",
};
